import { COLUMNS } from './keys';
import { query } from './query';
import DataTable from '../../../../components/Datatable';
import Component from '../../../../components/Component';
import { getDifference } from '../../../../helpers/showDelta';
import Loading from '../../../../components/Loading';
import { scrollForTable } from '../../../../components/Datatable/utils';
import { v4 as uuid } from 'uuid';
import ExtraButtons from './extraBtns';
import { withTranslation } from 'react-i18next';

class Directories extends Component {
    constructor(props) {
        super();
        if (!props.data) this.query = query();
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) =>
            item?.first_directory?.toLowerCase().includes(search.toLowerCase()),
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.data && JSON.stringify(this.state.data) !== JSON.stringify(prevState.data)) {
            this.props.updateDatas({ key: 'directories', value: this.state.data });
        }
    }

    render() {
        const { t } = this.props;

        let data = this.state.data?.length ? this.state.data : this.props.data;
        if ((!data || !data.length) && this.state.loading) return <Loading padding={10} />;
        data = data?.map((item) => ({ ...item, id: uuid() }));
        const sortFns = {
            cluster_name: (array) =>
                array.sort((a, b) => a.cluster_name.localeCompare(b.cluster_name)),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            avgCTR: (array) => array.sort((a, b) => a.avgCTR - b.avgCTR),
            avgPosition: (array) => array.sort((a, b) => a.avgPosition - b.avgPosition),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            weeks: (array) => array.sort((a, b) => a.weeks - b.weeks),
            impressions_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.impressions, a.impressionsPrior) -
                        getDifference(b.impressions, b.impressionsPrior),
                ),
            clicks_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.clicks, a.clicksPrior) -
                        getDifference(b.clicks, b.clicksPrior),
                ),
            avgPosition_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.avgPosition, a.avgPositionPrior) -
                        getDifference(b.avgPosition, b.avgPositionPrior),
                ),
            avgCTR_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.avgCTR, a.avgCTRPrior) -
                        getDifference(b.avgCTR, b.avgCTRPrior),
                ),
        };

        const extraBtns = () => <ExtraButtons t={t} />;

        return (
            <>
                <DataTable
                    nodes={data}
                    sortFns={sortFns}
                    COLUMNS={COLUMNS}
                    fileName={t('opportunities.directories.header')}
                    searchFunction={this.searchFunction}
                    forceRun={this.forceRun}
                    extraBtns={extraBtns}
                    header={t('opportunities.directories.header')}
                    customEmptyMessage={this.props.message}
                    viewAllLink={`/domains/${window.info.id}/gsc-reports/algo-comparison/?view=directories&defaultFilter=decline`}
                    showViewAll={true}
                    additionalStyles={{
                        Table: `
                                    --data-table-library_grid-template-columns : minmax(120px, 2fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                                ${scrollForTable}
                                `,
                        BaseCell: ` font-family: 'Raleway';
                                            font-weight: 500;
                                            font-size: 16px;
                                            line-height: 19px;
                                            padding: 16px 10px;
                                            color: #0D182C;
                                        
                                        
                                            &.underline {
                                            text-decoration: underline;
                                            }`,
                    }}
                />
                {(!data || !data?.length) && !this.state.filter && this.props.message && (
                    <div className="mt-10">
                        <div className="redirect-button">
                            <a
                                className="button button-filled button-primary"
                                href="/customers/change_plan/?without_basic=True"
                            >
                                {t('opportunities.adjust_plan')}
                            </a>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default withTranslation()(Directories);
